import { render, staticRenderFns } from "./agilityScore.vue?vue&type=template&id=8c28ac22&scoped=true&"
import script from "./agilityScore.vue?vue&type=script&lang=js&"
export * from "./agilityScore.vue?vue&type=script&lang=js&"
import style0 from "./agilityScore.vue?vue&type=style&index=0&id=8c28ac22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28ac22",
  null
  
)

export default component.exports